import 'bootstrap-duallistbox/dist/jquery.bootstrap-duallistbox.min';
import $ from 'jquery';

// используется в material.js

export function Dualbox() {
    if (!$('.u-material-page').length) {
        return;
    }

    $(function() {
        /**
         * sorting for authors list
         */

        function initDualBox(domRootElem) {
            // this.domRootElem = domRootElem;

            var selectedListLeft = [];
            var selectedListRight = [];
            var initialLeft = [];
            console.log($('.my-authors').html());
            var initialRight = JSON.parse($('.my-authors').html());
            var newRight = [];
            initialLeft = JSON.parse($('.my-authors-all').html());
            var formTextArea = $('.sorted-authors-list');

            var newArray = [];

            var arrayNewLeft = initialLeft.filter(function(item, index) {
                return !initialRight.some(function(itemTwo) {
                    return itemTwo.id === item.id;
                });
            });

            var INITITALRIGHT = Array.from(initialRight);
            initialRight = Array.from(initialRight);

            var INITITALLEFT = arrayNewLeft;
            initialLeft = Array.from(initialLeft);

            $('.material-authors-list').on('click', '.material-authors-list__item_left', function(
                e
            ) {
                $('.material-authors-list .material-authors-list__item_right').removeClass(
                    'selected'
                );
                $('.move-left-one').addClass('duallist__button_disabled');
                selectedListRight = [];
                $(this).toggleClass('selected');
                var selectedItemIndex = $(this).index();
                var selectedArrayItem = arrayNewLeft[selectedItemIndex];
                var indexSelectedInArray = selectedListLeft.findIndex(function(item) {
                    return item.id === selectedArrayItem.id;
                });

                if (indexSelectedInArray < 0) {
                    selectedListLeft.push(selectedArrayItem);
                    $('.move-right-one').removeClass('duallist__button_disabled');
                } else {
                    selectedListLeft.forEach(function(currentItem, index) {
                        if (currentItem.id === selectedArrayItem.id) {
                            selectedListLeft.splice(index, 1);
                            if (selectedListLeft.length === 0) {
                                $('.move-right-one').addClass('duallist__button_disabled');
                            }
                            return;
                        }
                    });
                }

                /**
                 * sort selected items by alphabet
                 */
                selectedListLeft.sort(function(a, b) {
                    if (a.name.trim()[0] < b.name.trim()[0]) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
            });

            $('.material-authors-list').on('click', '.material-authors-list__item_right', function(
                e
            ) {
                $('.material-authors-list .material-authors-list__item_left').removeClass(
                    'selected'
                );
                $('.move-right-one').addClass('duallist__button_disabled');
                selectedListLeft = [];
                $(this).toggleClass('selected');
                var selectedItemIndex = $(this).index();
                var selectedArrayItem = initialRight[selectedItemIndex];
                var indexSelectedInArray = selectedListRight.findIndex(function(item) {
                    return item.id === selectedArrayItem.id;
                });

                if (indexSelectedInArray < 0) {
                    selectedListRight.push(selectedArrayItem);
                    $('.move-left-one').removeClass('duallist__button_disabled');
                } else {
                    selectedListRight.forEach(function(currentItem, index) {
                        if (currentItem.id === selectedArrayItem.id) {
                            selectedListRight.splice(index, 1);
                            if (selectedListRight.length === 0) {
                                $('.move-left-one').addClass('duallist__button_disabled');
                            }
                            return;
                        }
                    });
                }
            });

            /**
             *
             * @param array
             * @param rootElemSelector
             * @param side = left || right
             */
            function createList(array, rootElemSelector, side) {
                var rootElement = document.getElementById(rootElemSelector);
                var fragment = document.createDocumentFragment();
                rootElement.innerHTML = '';

                Array.from(array).forEach(function(arrayItem) {
                    var liAuthorItem = document.createElement('li');
                    var spanItemKey = document.createElement('span');
                    var spanItemValue = document.createElement('span');
                    spanItemKey.className = 'item_key';
                    spanItemValue.className = 'item_val';
                    if (side === 'right') {
                        var divArrowUp = document.createElement('div');
                        var divArrowDown = document.createElement('div');
                        divArrowUp.className = 'duallist--item-arrow duallist--item-arrow_up';
                        divArrowDown.className = 'duallist--item-arrow duallist--item-arrow_down';
                        divArrowUp.innerHTML = '<span class="glyphicon glyphicon-arrow-up"></span>';
                        divArrowDown.innerHTML =
                            '<span class="glyphicon glyphicon-arrow-down"></span>';
                        liAuthorItem.className =
                            'material-authors-list__item material-authors-list__item_right';
                        spanItemKey.textContent = arrayItem.id;
                        spanItemValue.textContent = arrayItem.name;

                        liAuthorItem.appendChild(spanItemKey);
                        liAuthorItem.appendChild(spanItemValue);
                        liAuthorItem.appendChild(divArrowDown);
                        liAuthorItem.appendChild(divArrowUp);
                    } else {
                        liAuthorItem.className =
                            'material-authors-list__item material-authors-list__item_left';
                        spanItemKey.textContent = arrayItem.id;
                        spanItemValue.textContent = arrayItem.name;

                        liAuthorItem.appendChild(spanItemKey);
                        liAuthorItem.appendChild(spanItemValue);
                    }

                    fragment.appendChild(liAuthorItem);
                });
                rootElement.appendChild(fragment);
            }

            /**
             * move right
             */
            $('.move-right-one').on('click', function(e) {
                initialRight = initialRight.concat(selectedListLeft);

                arrayNewLeft = arrayNewLeft.filter(function(item) {
                    return !selectedListLeft.some(function(itemTwo) {
                        return itemTwo.id === item.id;
                    });
                });

                createList(initialRight, 'ul', 'right');
                createList(arrayNewLeft, 'ul_left', 'left');
                selectedListLeft = [];
                selectedListRight = [];

                addValuesToForm();
            });

            $('.move-left-one').on('click', function(e) {
                arrayNewLeft = selectedListRight.concat(arrayNewLeft);

                initialRight = initialRight.filter(function(item) {
                    return !selectedListRight.some(function(itemTwo) {
                        return itemTwo.id === item.id;
                    });
                });

                createList(initialRight, 'ul', 'right');
                createList(arrayNewLeft, 'ul_left', 'left');
                selectedListLeft = [];
                selectedListRight = [];

                addValuesToForm();
            });

            /**
             * Sort list
             */
            $('.material-authors-list').on('click', '.duallist--item-arrow_up', function(e) {
                e.stopPropagation();

                var selectedItem = '';
                var currentIndex = $(this)
                    .closest('.material-authors-list__item')
                    .index();
                var currentItem = initialRight[currentIndex];
                var currentLength = initialRight.length;

                if (currentIndex !== 0) {
                    initialRight.splice(currentIndex, 1);
                    initialRight.splice(currentIndex - 1, 0, currentItem);
                    createList(initialRight, 'ul', 'right');

                    var movedDom = $('.material-authors-list__item_right')[currentIndex - 1];

                    $(movedDom).addClass('moved-up');
                } else {
                    initialRight.splice(0, 1);
                    initialRight.push(currentItem);
                    createList(initialRight, 'ul', 'right');

                    var movedDom = $('.material-authors-list__item_right')[currentLength - 1];

                    $(movedDom).addClass('moved-up');
                }

                addValuesToForm();
            });

            $('.material-authors-list').on('click', '.duallist--item-arrow_down', function(e) {
                e.stopPropagation();

                var currentIndex = $(this)
                    .closest('.material-authors-list__item')
                    .index();
                var currentItem = initialRight[currentIndex];
                var currentLength = initialRight.length;

                if (currentIndex !== currentLength - 1) {
                    initialRight.splice(currentIndex, 1);
                    initialRight.splice(currentIndex + 1, 0, currentItem);
                    createList(initialRight, 'ul', 'right');

                    var movedDom = $('.material-authors-list__item_right')[currentIndex + 1];

                    $(movedDom).addClass('moved-down');
                } else {
                    initialRight.splice(currentLength - 1, 1);
                    initialRight.unshift(currentItem);
                    createList(initialRight, 'ul', 'right');

                    var movedDom = $('.material-authors-list__item_right')[0];

                    $(movedDom).addClass('moved-down');
                }

                addValuesToForm();
            });

            /**
             * filter
             */
            $('.duallist__filter_left').on('input', function() {
                var inputValue = $(this).val();

                $('#ul_left')
                    .find('li')
                    .get()
                    .forEach(function(item) {
                        if (
                            $(item)
                                .find('.item_val')
                                .html()
                                .toLowerCase()
                                .indexOf(inputValue.toLowerCase()) < 0 &&
                            $(item)
                                .find('.item_key')
                                .html()
                                .indexOf(inputValue) < 0
                        ) {
                            $(item).hide();
                        } else {
                            $(item).show();
                        }
                    });
            });

            function addValuesToForm() {
                var textAreaValue = initialRight.map(function(item, index) {
                    item.position = index;
                    return item;
                });

                if (textAreaValue.length) {
                    formTextArea.val(JSON.stringify(textAreaValue));
                } else {
                    formTextArea.val(JSON.stringify([]));
                }

                $('.duallist__button').addClass('duallist__button_disabled'); //дизейблит кнопки
            }

            function createLists() {
                createList(INITITALRIGHT, 'ul', 'right');
                createList(INITITALLEFT, 'ul_left', 'left');
            }

            createLists();
        }

        initDualBox('some');

        function DualBox(domRootElem, domItemLeft, domItemRight) {
            this.domRootElem = domRootElem;
            this.domItemLeft = domItemLeft;
            this.domItemRight = domItemRight;

            this.selectedListLeft = [];
            this.selectedListRight = [];
            this.initialRight = JSON.parse($('.my-authors').html());
            this.initialLeft = JSON.parse($('.my-authors-all').html());

            this.arrayNewLeft = this.initialLeft.filter(function(item) {
                return !initialRight.some(function(itemTwo) {
                    return itemTwo.id === item.id;
                });
            });

            this.INITITALRIGHT = Array.from(this.initialRight);
            this.initialRight = Array.from(this.initialRight);

            this.INITITALLEFT = arrayNewLeft;
        }

        function buildTree() {
            var rightTree = JSON.parse($('.categories').html());
            var leftTree = JSON.parse($('.categories_all').html());
        }

        var rightTree = JSON.parse($('.categories').html());
        var leftTree = JSON.parse($('.categories_all').html());

        var moveCategoriesToRightBtn = $('.duallist-categories .move-right-one');
        var moveCategoriesToLeftBtn = $('.duallist-categories .move-left-one');

        /**
         * GlobalProps
         */

        var _sortedTree = leftTree;
        var _categoriesTextArea = $('.categories-list-textarea');
        var _clickedTargetId = null;
        var _openClickedListTargetId = [];
        var _closedClickedListTargetId = [];
        var _currentInputValue = '';
        var _selectedCategoriesLeft = [];
        var _selectedCategoriesRight = [];
        var _rightList = rightTree.map(function(item) {
            return item.id;
        });

        $('.duallist-categories').on('click', '.categorie__show-child-btn', function(e) {
            var targetId = $(this)
                .siblings('.categorie_val')
                .data('key');
            _clickedTargetId = targetId;

            if (_openClickedListTargetId.indexOf(targetId) < 0) {
                addChildren(targetId);
            } else if (_closedClickedListTargetId.indexOf(targetId) < 0) {
                // remove children
                removeChildren(targetId);
            }
        });

        function _addValuesToForm() {
            // var textAreaValue = initialRight.map(function(item, index) {
            //     item.position = index;
            //     return item;
            // });

            var items = getArrayItemsById(
                _rightList
            ); /*.map(function(i) {
           return i.name;
        });*/

            if (_rightList.length > 0) {
                _categoriesTextArea.val(JSON.stringify(items));
            } else {
                _categoriesTextArea.val('');
            }

            console.table(items);

            $('.duallist__button').addClass('duallist__button_disabled'); //дизейблит кнопки
        }

        function addChildren(id) {
            var itemChildren = leftTree.find(function(item) {
                return item.id === id;
            }).children;

            var itemChildrenArray = leftTree.filter(function(item) {
                return itemChildren.some(function(child) {
                    return child.id === item.id;
                });
            });

            var parentIndex = _sortedTree.findIndex(function(i) {
                return i.id === id;
            });

            var startReplacementIndex = parentIndex + 1;

            _sortedTree.splice.apply(
                _sortedTree,
                [startReplacementIndex, 0].concat(itemChildrenArray)
            );
            _closedClickedListTargetId = [];
            _openClickedListTargetId = [];

            createListCategories(
                _sortedTree,
                'ul_left_categories',
                true,
                _currentInputValue,
                'click'
            );
        }

        function removeChildren(id) {
            var itemChildrenLength = leftTree.find(function(item) {
                return item.id === id;
            }).children.length;

            var parentIndex = _sortedTree.findIndex(function(i) {
                return i.id === id;
            });

            _sortedTree = _sortedTree.filter(function(item) {
                return !item.ancestors.some(function(ancestor) {
                    return ancestor.id === id;
                });
            });

            _closedClickedListTargetId = [];
            _openClickedListTargetId = [];

            createListCategories(
                _sortedTree,
                'ul_left_categories',
                true,
                _currentInputValue,
                'click'
            );
        }

        $('.duallist__filter_categories').on('input', function() {
            $('.duallist-categories .duallist-wrapper').scrollTop(0);

            _closedClickedListTargetId = [];
            _openClickedListTargetId = [];
            var currentValue = $(this)
                .val()
                .toLowerCase();
            // if (currentValue.length < 3) {
            //     currentValue = '';
            //     return;
            // }
            _currentInputValue = currentValue;

            var sortedList = leftTree.filter(function(i) {
                if (i.name.toLowerCase().indexOf(currentValue) > -1) {
                    return true;
                } else {
                    return leftTree.some(function(item) {
                        return item.ancestors.some(function(parent) {
                            return (
                                i.id === parent.id &&
                                item.name.toLowerCase().indexOf(currentValue) > -1
                            );
                        });
                    });
                }
            });
            _sortedTree = sortedList;
            createListCategories(sortedList, 'ul_left_categories', true, currentValue, 'input');
        });

        /**
         *
         * @param array
         * @param rootElemSelector
         * @param side = left || right
         */
        function createListCategories(
            itemsArray,
            rootElemSelector,
            withPlussButton,
            currentInputValue
        ) {
            if (withPlussButton) {
                var rootElement = document.getElementById(rootElemSelector);
                var fragment = document.createDocumentFragment();

                rootElement.innerHTML = '';

                itemsArray.forEach(function(item) {
                    var arrayItem = item;

                    var liCategoryItem = document.createElement('li');
                    var spanItemValue = document.createElement('span');
                    var spanPlusIcon = document.createElement('span');
                    var spanMinusIcon = document.createElement('span');
                    var depth = arrayItem.level;
                    spanPlusIcon.className =
                        'categorie__show-child-btn glyphicon glyphicon glyphicon-plus';
                    spanMinusIcon.className = 'categorie__show-child-btn glyphicon glyphicon-minus';
                    spanItemValue.className = 'categorie_val';
                    var liCategoryClass = 'li-depth-' + depth;
                    liCategoryClass =
                        _selectedCategoriesLeft.indexOf(item.id) > -1
                            ? liCategoryClass + ' selected'
                            : liCategoryClass;
                    liCategoryClass =
                        _rightList.indexOf(item.id) > -1
                            ? liCategoryClass + ' added'
                            : liCategoryClass;
                    liCategoryItem.className = liCategoryClass;

                    spanItemValue.dataset.key = arrayItem.id;

                    // add mark
                    var result = arrayItem.name;
                    var searchterm = currentInputValue.trim();

                    searchterm.split().forEach(function(item) {
                        result = result.replace(new RegExp(`(${item})`, 'ig'), '<mark>$1</mark>');
                    });

                    // add mark
                    spanItemValue.innerHTML =
                        Array(depth + 1).join('<span class="categorie-pre-line"></span>') +
                        ' ' +
                        result;

                    liCategoryItem.appendChild(spanItemValue);

                    if (
                        arrayItem.children.length > 0 &&
                        !arrayItem.children.some(function(child) {
                            return itemsArray.some(function(a) {
                                return a.id === child.id;
                            });
                        })
                    ) {
                        liCategoryItem.appendChild(spanPlusIcon);
                        _closedClickedListTargetId.push(arrayItem.id);
                        if (_openClickedListTargetId.indexOf(arrayItem.id) > -1) {
                            _openClickedListTargetId.splice(
                                _openClickedListTargetId.indexOf(arrayItem.id),
                                1
                            );
                        }
                    } else if (
                        arrayItem.children.length > 0 &&
                        arrayItem.children.some(function(child) {
                            return itemsArray.some(function(a) {
                                return a.id === child.id;
                            });
                        })
                    ) {
                        liCategoryItem.appendChild(spanMinusIcon);
                        _openClickedListTargetId.push(arrayItem.id);
                        if (_closedClickedListTargetId.indexOf(arrayItem.id) > -1) {
                            _closedClickedListTargetId.splice(
                                _closedClickedListTargetId.indexOf(arrayItem.id),
                                1
                            );
                        }
                    }

                    fragment.appendChild(liCategoryItem);
                });
                rootElement.appendChild(fragment);
            } else {
                var rootElement = document.getElementById(rootElemSelector);
                var fragment = document.createDocumentFragment();

                rootElement.innerHTML = '';

                itemsArray.forEach(function(arrayItem) {
                    var liCategoryItem = document.createElement('li');
                    // var spanItemKey = document.createElement('span');
                    var spanItemValue = document.createElement('span');
                    var spanPlusIcon = document.createElement('span');
                    var depth = arrayItem.level;
                    spanPlusIcon.className =
                        'categorie__show-child-btn glyphicon glyphicon-chevron-right ';
                    spanItemValue.className = 'categorie_val';
                    var liCategoryClass = 'li-depth-' + depth;
                    liCategoryItem.className = liCategoryClass;

                    spanItemValue.dataset.key = arrayItem.id;
                    spanItemValue.innerHTML =
                        Array(depth + 1).join('<span class="categorie-pre-line"></span>') +
                        arrayItem.name;

                    liCategoryItem.appendChild(spanItemValue);

                    fragment.appendChild(liCategoryItem);
                });
                rootElement.appendChild(fragment);
            }
        }

        /**
         * select items from left list
         *  toggle list
         */

        $('#ul_left_categories').on('click', 'li', function(e) {
            if (
                $(e.target).hasClass('open-list') ||
                $(e.target).hasClass('categorie__show-child-btn')
            ) {
                return;
            }

            var that = $(this);

            var itemId = that.find('.categorie_val').data('key');

            if (_selectedCategoriesLeft.indexOf(itemId) < 0) {
                _selectedCategoriesLeft = []; // @note new выбрать можно только один элемент
                _selectedCategoriesLeft.push(itemId);
            } else {
                _selectedCategoriesLeft = _selectedCategoriesLeft.filter(function(i) {
                    return i !== itemId;
                });
            }

            if (that.hasClass('added')) {
                return false;
            }
            if (that.hasClass('selected')) {
                that.removeClass('selected');
            } else {
                $('li.selected').removeClass('selected');
                that.addClass('selected');
            }

            if (_selectedCategoriesLeft.length) {
                moveCategoriesToRightBtn.removeClass('duallist__button_disabled');
            } else {
                moveCategoriesToRightBtn.addClass('duallist__button_disabled');
            }
        });

        moveCategoriesToRightBtn.on('click', function(e) {
            _rightList = _rightList.concat(_selectedCategoriesLeft);

            createListCategories(getArrayItemsById(_rightList), 'ul_right_categories', false);
            $('#ul_left_categories')
                .find('.selected')
                .addClass('added');

            _selectedCategoriesLeft = [];

            _addValuesToForm();
        });

        $('#ul_right_categories').on('click', 'li', function(e) {
            if (
                $(e.target).hasClass('open-list') ||
                $(e.target).hasClass('categorie__show-child-btn')
            ) {
                return;
            }

            var that = $(this);
            var itemId = that.find('.categorie_val').data('key');

            if (_selectedCategoriesRight.indexOf(itemId) < 0) {
                _selectedCategoriesRight.push(itemId);
            } else {
                _selectedCategoriesRight = _selectedCategoriesRight.filter(function(i) {
                    return i !== itemId;
                });
            }

            if (that.hasClass('selected')) {
                that.removeClass('selected');
            } else {
                that.addClass('selected');
            }

            if (_selectedCategoriesRight.length) {
                moveCategoriesToLeftBtn.removeClass('duallist__button_disabled');
            } else {
                moveCategoriesToLeftBtn.addClass('duallist__button_disabled');
            }
        });

        moveCategoriesToLeftBtn.on('click', function(e) {
            _selectedCategoriesLeft = [];

            _rightList = _rightList.filter(function(itemId) {
                return !_selectedCategoriesRight.some(function(id) {
                    return id === itemId;
                });
            });

            createListCategories(getArrayItemsById(_rightList), 'ul_right_categories', false, '');
            createListCategories(_sortedTree, 'ul_left_categories', true, '');

            _selectedCategoriesRight = [];
            _addValuesToForm();
        });

        function getArrayItemsById(idsArray) {
            var arrayItems = leftTree.filter(function(leftTreeItem) {
                return idsArray.some(function(id) {
                    return leftTreeItem.id === id;
                });
            });

            return arrayItems;
        }

        buildTree();
        createListCategories(leftTree, 'ul_left_categories', false);
        _addValuesToForm();
        createListCategories(getArrayItemsById(_rightList), 'ul_right_categories', false);
    });
}
